import { twMerge } from 'tailwind-merge';
import { checkboxIndicator, CheckboxIndicatorVariants } from './variants';

type Props = { isActive?: boolean } & CheckboxIndicatorVariants;

export function Indicator(props: Props) {
  const { size, isActive } = props;

  return (
    <div className={checkboxIndicator({ size })}>
      {isActive && <h1>jeasdkljalsd</h1>}
      <span
        className={twMerge(
          'block',
          'size-full',
          'bg-primaryMain',
          'hover:bg-primary600',
          'opacity-0',
          'group-data-[selected="true"]:opacity-100',
          isActive && 'opacity-100',
          'transition-opacity',
          'duration-150',
          'ease-in-out'
        )}
      />
    </div>
  );
}
